import PartnerCard from '@/pages/Contacts/Cards/PartnerCard';
import ContactList from '@/pages/Contacts/ContactList';
import {partnerSearchKeys, partnerSort, useSearch} from '@/pages/Contacts/helpers/search';
import {useContactsByTypeQuery} from '@/queries/contact';

const VendorPartners = () : JSX.Element => {
    const contactsQuery = useContactsByTypeQuery('vp');
    const search = useSearch(contactsQuery, partnerSort, partnerSearchKeys);

    return (
        <ContactList
            title="Vendor Partners"
            contactsQuery={contactsQuery}
            search={search}
            renderCard={contact => (
                <PartnerCard contact={contact}/>
            )}
        />
    );
};

export default VendorPartners;
